module.exports = __webpack_public_path__ + "img/scopeBG.d8b983be.png";